export const SOMETHING_WENT_WRONG = 'Something went wrong!!!';
export const NO_RESULTS_FOUND = 'No Results for ';
